<div id="layout-wrapper">

  <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()">
  </app-topbar>

  <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

  <div class="main-content bay-main-content">
    <div class="page-content bay-page-content">
      <bay-bandeau-abonnement></bay-bandeau-abonnement>
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>

</div>

<!-- Bouton « + » global : Vente · Dépense · Encaissement -->
<bay-ajout-rapide *ngIf="!estContenu"></bay-ajout-rapide>

<!-- Bottom Nav mobile — design prototype -->
<nav class="bay-bottom-nav d-lg-none" *ngIf="!estContenu">
  <div class="bay-bottom-nav-inner">

    <a routerLink="/dashboard" routerLinkActive="bay-bnav-active"
       [routerLinkActiveOptions]="{exact: true}" class="bay-bnav-item">
      <span class="material-symbols-outlined">home</span>
      <span class="bay-bnav-label">Accueil</span>
    </a>

    <a routerLink="/maraichage" routerLinkActive="bay-bnav-active" class="bay-bnav-item">
      <span class="material-symbols-outlined">agriculture</span>
      <span class="bay-bnav-label">Cultures</span>
    </a>

    <a routerLink="/betail" routerLinkActive="bay-bnav-active" class="bay-bnav-item">
      <span class="material-symbols-outlined">pets</span>
      <span class="bay-bnav-label">Bétail</span>
    </a>

    <a routerLink="/finances" routerLinkActive="bay-bnav-active" class="bay-bnav-item">
      <span class="material-symbols-outlined">payments</span>
      <span class="bay-bnav-label">Finance</span>
    </a>

    <button type="button" class="bay-bnav-item"
            [class.bay-bnav-active]="isMoreActive()"
            (click)="toggleMoreDrawer()">
      <span class="material-symbols-outlined">apps</span>
      <span class="bay-bnav-label">Voir plus</span>
    </button>

  </div>
</nav>

<!-- Overlay backdrop for "Voir plus" drawer (mobile only) -->
<div class="bay-more-overlay d-lg-none"
     [class.bay-more-overlay-visible]="showMoreDrawer"
     (click)="closeMoreDrawer()">
</div>

<!-- "Voir plus" slide-up drawer (mobile only) -->
<div class="bay-more-drawer d-lg-none"
     [class.bay-more-drawer-open]="showMoreDrawer"
     role="dialog" aria-label="Navigation secondaire">

  <div class="bay-more-drawer-handle"></div>

  <p class="bay-more-drawer-title">Navigation</p>

  <!-- Élevage & Aquaculture -->
  <div class="bay-more-section">
    <span class="bay-more-section-label">Élevage &amp; Aquaculture</span>
    <div class="bay-more-grid">
      <a routerLink="/volaille" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/volaille')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">egg</span>
        <span>Poulailler</span>
      </a>
      <a routerLink="/bassins" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/bassins')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">water</span>
        <span>Bassins</span>
      </a>
      <a routerLink="/pisciculture" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/pisciculture')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">set_meal</span>
        <span>Cohortes poissons</span>
      </a>
    </div>
  </div>

  <!-- Gestion -->
  <div class="bay-more-section">
    <span class="bay-more-section-label">Gestion</span>
    <div class="bay-more-grid">
      <a routerLink="/taches" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/taches')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">checklist</span>
        <span>Tournées</span>
      </a>
      <a routerLink="/stock" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/stock')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">inventory_2</span>
        <span>Stock</span>
      </a>
      <a routerLink="/equipements" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/equipements')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">construction</span>
        <span>Équipements</span>
      </a>
      <a *ngIf="!estContenu" routerLink="/galerie" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/galerie')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">photo_library</span>
        <span>Galerie</span>
      </a>
      <a routerLink="/journal" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/journal')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">history</span>
        <span>{{ estContenu || estPersonnelJournal ? 'Mon activité' : 'Journal' }}</span>
      </a>
      <a routerLink="/impact" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/impact')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">volunteer_activism</span>
        <span>Impact</span>
      </a>
      <a routerLink="/contacts-crm" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/contacts-crm')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">contacts</span>
        <span>CRM</span>
      </a>
      <a routerLink="/factures" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/factures')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">receipt_long</span>
        <span>Factures</span>
      </a>
      <a routerLink="/ged" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/ged')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">folder_open</span>
        <span>Documents</span>
      </a>
    </div>
  </div>

  <!-- Outils -->
  <div class="bay-more-section">
    <span class="bay-more-section-label">Outils</span>
    <div class="bay-more-grid">
      <a routerLink="/farm-map" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/farm-map')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">map</span>
        <span>Carte ferme</span>
      </a>
      <a routerLink="/statistiques" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/statistiques')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">bar_chart</span>
        <span>Statistiques</span>
      </a>
      <a *ngIf="voitAnalyste" routerLink="/analyste" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/analyste')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">insights</span>
        <span>Analyste</span>
      </a>
      <a *ngIf="voitArticles" routerLink="/articles" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/articles')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">article</span>
        <span>Articles du site</span>
      </a>
      <a routerLink="/partenaires" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/partenaires')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">handshake</span>
        <span>Partenaires</span>
      </a>
      <a routerLink="/fermes" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/fermes')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">cottage</span>
        <span>Ma ferme</span>
      </a>
      <a routerLink="/users" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/users')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">group</span>
        <span>Utilisateurs</span>
      </a>
      <a routerLink="/types-animaux" class="bay-more-tile"
         [class.bay-more-tile-active]="isRoute('/types-animaux')"
         (click)="closeMoreDrawer()">
        <span class="material-symbols-outlined">category</span>
        <span>Types animaux</span>
      </a>
    </div>
  </div>

  <button type="button" class="bay-more-close-btn" (click)="closeMoreDrawer()">
    <span class="material-symbols-outlined">close</span>
    Fermer
  </button>

  <button type="button" class="bay-more-logout-btn" (click)="logout()">
    <span class="material-symbols-outlined">logout</span>
    Déconnexion
  </button>

</div>
